import React from 'react';
import ReactDOM from "react-dom";
import Header from './Header';
// Global interaction-feedback layer — the Header entry is on every page,
// so importing it here ships the juice app-wide.
import "../../styles/juice.css";
// Hover/touch prefetch for near-instant page navigation.
import "../../utils/prefetch";
// Success toasts + the after-reload flush (side effect on import).
import "../../utils/successToast";

document.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render(
    <Header />,
    document.body.appendChild(document.createElement("div"))
  );
});